import { useSyncExternalStore } from 'react';

// PortalSidePanel sits beside the page from `lg`; below that it covers the page, so there it opens only when asked.
const BESIDE_QUERY = '(min-width: 64rem)';

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia(BESIDE_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
};

/** Whether the chat's side panel has room beside the page. */
export const useIsPanelBeside = () =>
  useSyncExternalStore(
    subscribe,
    () => window.matchMedia(BESIDE_QUERY).matches,
    () => true,
  );
